import React from 'react';
import SocialButton from './social-button/social-button';
import { FaDiscord, FaTwitter, FaTwitch, FaPatreon, FaYoutube, FaGithub } from 'react-icons/fa';
import AhadLogo from '../../assets/images/ahadtransparent.png';
import './nav.css';

function Nav() {
	const selectedSite = (site) => {
		switch (site) {
			case 'youtube':
				window.open('https://www.youtube.com/ahadcove', '_blank');
				break;
			case 'twitter':
				window.open('https://twitter.com/AhadCove', '_blank');
				break;
			case 'twitch':
				window.open('https://www.twitch.tv/ahadcove', '_blank');
				break;
			case 'discord':
				window.open('https://discord.gg/zjUrYyG', '_blank');
				break;
			case 'patreon':
				window.open('https://www.patreon.com/ahadcove', '_blank');
				break;
			case 'github':
				window.open('http://github.com/ahadcove', '_blank');
				break;
		}
	};

	return (
		<div className='nav'>
			<div className='logo-contain'>
				<img className='logo' src={AhadLogo} />
			</div>
			<div className='socials'>
				<SocialButton Icon={FaYoutube} site='YouTube' background={'#c4302b'} pressedSocial={() => selectedSite('youtube')} />
				<SocialButton Icon={FaTwitter} site='Twitter' background={'#6441a5'} pressedSocial={() => selectedSite('twitter')} />
				<SocialButton Icon={FaTwitch} site='Twitch' background={'#6441a5'} pressedSocial={() => selectedSite('twitch')} />
				<SocialButton Icon={FaDiscord} site='Discord' background={'#3b5998'} pressedSocial={() => selectedSite('discord')} />
				<SocialButton Icon={FaPatreon} site='Patreon' background={'#3b5998'} pressedSocial={() => selectedSite('patreon')} />
				<SocialButton Icon={FaGithub} site='Github' background={'#0000FF'} pressedSocial={() => selectedSite('github')} />
			</div>
		</div>
	);
}

export default Nav;
